import { render, staticRenderFns } from "./AcceptOrder.vue?vue&type=template&id=b75cda3e&scoped=true&"
import script from "./AcceptOrder.vue?vue&type=script&lang=js&"
export * from "./AcceptOrder.vue?vue&type=script&lang=js&"
import style0 from "./AcceptOrder.vue?vue&type=style&index=0&id=b75cda3e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b75cda3e",
  null
  
)

export default component.exports